import {Spinner} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../../components/Div.styled';
import EmptyResult from '../../components/EmptyResults';
import Icon from '../../components/Icon';
import SpaceLike from '../../components/Space';
import TypographyBody from '../../components/Typography/TypographyBody';
import {convertDataForQuestionManualThree} from '../../helpers/questionManualTransformData';
import {
  OptionManualThree,
  QuestionManualContent,
  ResultQuestionThree,
  ResultQuestions,
  SelectManualProps,
} from '../../types/questionManuals';
import {config} from '../../environment';

interface QuestionManualThreeProps {
  handleNextStep: () => void;
  currentQuestion: QuestionManualContent;
  handleSelect: (data: SelectManualProps) => void;
  results: ResultQuestions[];
}

export default function QuestionManualThree({
  handleNextStep,
  currentQuestion,
  handleSelect,
  results,
}: QuestionManualThreeProps) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [filteredData, setFilteredData] = React.useState<OptionManualThree[]>(
    [],
  );

  React.useEffect(() => {
    const fetchState = async () => {
      try {
        const makeQuestion = results.find((item) => item.id === 'model');

        if (makeQuestion && makeQuestion.makeCode && makeQuestion.familyCode) {
          const questionThreeData = await fetch(
            `${config.API_REDBOOK_MODEL_YEARS_URL}`,
            {
              method: 'POST',
              body: JSON.stringify({
                familycode: makeQuestion.familyCode,
                makecode: makeQuestion.makeCode,
              }),
              headers: {
                'Content-Type': 'application/json',
              },
              mode: 'cors',
            },
          );

          const result: {data: ResultQuestionThree[]} =
            await questionThreeData.json();
          const transformedData = convertDataForQuestionManualThree(
            result.data,
          );
          setFilteredData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchState();
  }, [results]);

  return (
    <SpaceLike
      direction="vertical"
      size={40}
      customStyles={{
        marginTop: 40,
        padding: '0 16px',
      }}
      className="no-scroll"
      width={'100%'}
    >
      {loading ? (
        <Div width="100%" customStyles={{textAlign: 'center'}}>
          <Spinner variant="large" />
        </Div>
      ) : filteredData?.length > 0 ? (
        filteredData?.map((item, index) => {
          return (
            <TypographyBody
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: 0,
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={() => {
                handleSelect({
                  id: currentQuestion.id || '',
                  value: item.description,
                  makeCode: item.makeCode,
                  vehicletype: item.vehicletype,
                  year: item.year || '',
                  month: item.month || '',
                  familyCode: item.familyCode || '',
                });
                handleNextStep();
              }}
            >
              {item.description}
              <Icon icon="arrow-right-alt" color="white" />
            </TypographyBody>
          );
        })
      ) : (
        <EmptyResult />
      )}
    </SpaceLike>
  );
}
